'use strict';
{
    var app = angular.module('tf.blotter', [])
        .controller('blotterCtrl', ['$scope', '$state', 'uiGridConstants', '$localStorage', '$timeout', '$http', '$aside', 'terms', 'uiGridGroupingConstants', 'userConfig', function blotterController($scope, $state, uiGridConstants, $localStorage, $timeout, $http, $aside, terms, uiGridGroupingConstants, userConfig) {

            $scope.gridOptions = {
                excessRows : 25,
                minRowsToShow : 15,
                enableFiltering: true,
                onRegisterApi: function(gridApi){
                    $scope.gridApi = gridApi;
                },
                columnDefs: [
                    //{
                    //    name: 'orderType',
                    //    type : 'string',
                    //    grouping: { groupPriority: 0 }, sort: { priority: 0, direction: 'desc' },
                    //    displayName: 'Order Type',
                    //    width: '*',
                    //    headerCellTemplate: 'tf/uiGridHeaderCell',
                    //    cellTooltip: true,
                    //    filter: {
                    //        condition: uiGridConstants.filter.CONTAINS
                    //    }
                    //},
                    {
                        name: 'orderName',
                        type : 'string',
                        grouping: { groupPriority: 1 }, sort: { priority: 0, direction: 'asc' },
                        displayName: 'Order Name',
                        width: '*',
                        headerCellTemplate: 'tf/uiGridHeaderCell',
                        cellTooltip: true,
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    {
                        name: 'qty', type: 'number', headerCellTemplate: 'tf/uiGridHeaderCell', term: terms.qty,
                            enableFiltering: false, enableHiding: false, enableColumnResizing: true,
                            cellTooltip: true, treeAggregationType: uiGridGroupingConstants.aggregation.SUM,
                            displayName: 'Quantity', width: '100', cellClass: 'gridQty'
                    },
                    {
                        name: 'accountNumber',
                        type : 'string',
                        displayName: 'Account Number',
                        width: '*',
                        headerCellTemplate: 'tf/uiGridHeaderCell',
                        term: terms.accNum,
                        cellTooltip: true,
                        grouping: { groupPriority: 2 }, sort: { priority: 0, direction: 'asc' },
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    {
                        name: 'accountName',
                        type : 'string',
                        displayName: 'Account Name',
                        width: '**',
                        headerCellTemplate: 'tf/uiGridHeaderCell',
                        term: terms.accName,
                        cellTooltip: true,
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    {
                        name: 'instrument',
                        type : 'string',
                        displayName: 'Instrument',
                        width: '**',
                        headerCellTemplate: 'tf/uiGridHeaderCell',
                        cellTooltip: true,
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    {
                        name: 'theo',
                        type : 'number', cellTooltip: true,
                        displayName: 'Theoretical', width: '*',
                        headerCellTemplate: 'tf/uiGridHeaderCell',
                        headerCellClass: 'gridNumber', cellClass: 'gridNumber', footerCellClass: 'gridNumber',
                        filter: {
                            condition: uiGridConstants.filter.GREATER_THAN
                        },
                        footerCellFilter: 'ledger'
                    },
                    {
                        name: 'status',
                        type : 'string',
                        displayName: 'Confirmed',
                        width: '*',
                        headerCellTemplate: 'tf/uiGridHeaderCell',
                        grouping: { groupPriority: 3 }, sort: { priority: 0, direction: 'asc' },
                        cellTooltip: true,
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    {
                        name:'4', displayName:'Status',
                        cellTemplate: '<div class="ui-grid-cell-contents">' +
                        '<div style="width: 18px; height: 18px; border: 2px solid #3434A7; border-radius: 5px; background: #3434A7; display: inline-block; margin-right: 5px; cursor: pointer"></div>' +
                        '<div style="width: 18px; height: 18px; border: 2px solid #FF8100; border-radius: 5px; background: #FF8100; display: inline-block; margin-right: 5px; cursor: pointer"></div>' +
                        '<div style="width: 18px; height: 18px; border: 2px solid green; border-radius: 5px; display: inline-block;margin-right: 5px; cursor: pointer"></div>' +
                        '</div>'}


                ]
            };

            $http.get('app/blotter/data.json')
                .then(function(response) {
                    var data = response.data;

                    $scope.gridOptions.data = data;

                });

            $scope.state = {};



            $scope.filter = function() {
                $scope.gridApi.grid.refresh();
            };

            //$scope.singleFilter = function( renderableRows ){
            //    var matcher = new RegExp($scope.filterValue);
            //    renderableRows.forEach( function( row ) {
            //        var match = false;
            //        [ 'instrument', 'orderName', 'accountNumber' ].forEach(function( field ){
            //            if ( row.entity[field].match(matcher) ){
            //                match = true;
            //            }
            //        });
            //        if ( !match ){
            //            row.visible = false;
            //        }
            //    });
            //    return renderableRows;
            //};

        }]);



}
